import React, { Component } from 'react';
import Ribbon from 'src/components/RibbonNew/Ribbon.jsx';
import { getBookmark } from '../../requests/loader';
import settings from '../../devices/all/settings';
import logger from 'src/utils/logger/logger';

class Episodes extends Component {
    constructor(props) {
        super(props);
        this.state = {
          response: '',
          loadingBookmarks: true,
          items: [],
          bookmarkError: false,
        };
        this.lastTouchSeen = props.lastTouchSeen

        this.buildEpisodes = this.buildEpisodes.bind(this);
        this.handleErrorImg = this.handleErrorImg.bind(this);
        this.setBookmarkEpisodes = this.setBookmarkEpisodes.bind(this);
        this.handleUpdateProgress = this.handleUpdateProgress.bind(this);
    }

    async getAllBookmarks(groupId = "") {
        return await getBookmark(groupId, this.lastTouchSeen);
    }

    requesthandler() {
        logger.debug("REQUESTHANDLER EPISODES");
        let groupIdArray = this.props.episodes.map(ep => (ep.id));
        let that = this;
        this.getAllBookmarks(groupIdArray.toString()).then(function (response) {
            that.setState({ response: response.response.groups, loadingBookmarks: false })
        }).catch(function (error) {
            that.setState({ response: '', loadingBookmarks: false, bookmarkError: true })
        });
    }

    componentDidMount() {
      this.requesthandler();
      document.addEventListener(settings.update_progress, this.handleUpdateProgress);
    }

    componentWillUnmount() {
      document.removeEventListener(settings.update_progress, this.handleUpdateProgress);
    }

    handleUpdateProgress(e) {
      this.requesthandler();
      this.setBookmarkEpisodes(e);
    }

    focusElement() {
        let modal = document.getElementsByClassName("modal-container");
        let visibleModal = false;
        if(modal && modal[0]){
          visibleModal = true;
        }
        if(visibleModal){

          [...document.querySelectorAll(`.modal-container .ribbon-items .card`)].map( (currentValue, index) => {
            if(index === 0){
              const id = currentValue.getAttribute("id");
              const idLink = document.getElementById(id).children[0].children[0].getAttribute("id");
              window.SpatialNavigation.focus(`#${idLink}`);
            }
          });
        }
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.episodes) !== JSON.stringify(this.props.episodes)) {
            this.buildEpisodes();
            this.requesthandler();
        }
        logger.debug("MUERE EPISODES");
        this.focusElement();

        if(!this.state.loadingBookmarks) {
          this.checkBookmarkEpisodes();
        }
    }

    componentWillMount(){
        this.buildEpisodes();
        logger.debug("NACE EPISODES");
    }

    handleErrorImg(image_frames, image_still) {
      return new Promise(resolve => {
        let image = new Image();
        image.src = image_frames;
        image.onerror = function () {
          resolve(image_still);
        };
        image.onload = function () {
          resolve(image_frames);
        };
      })
    }

    checkBookmarkEpisodes = async () => {
      const { response, items } = this.state;
      if(response){
        const haveBookmarks = response.length > 0 && items.length > 0;

        if(haveBookmarks) {
          this.setBookmarkEpisodes();
        }
      }
    }

    getCoverImage (image) {
      return image &&
        image.indexOf &&
        image.indexOf('?') == -1
          ? image + '?size&imwidth=286'
          : image + '&size&imwidth=286'
    }

  setBookmarkEpisodes(e) {
    let cover = null;
    let withResponseBookmark = false;

    const items = this.state.items.map( ep => {
      let responseBookmark = null;
      let image_still = null;

      if(this.state.response) {
        withResponseBookmark = true;
        responseBookmark = this.state.response.find(bookmark => bookmark.id == ep.id);
        image_still = ep.image_still && ep.image_still.indexOf && ep.image_still.indexOf('?') == -1 ? ep.image_still + '?size&imwidth=286' : ep.image_still + '&size&imwidth=286';

        //FIX para mostar el progress actualizado viniendo de reproduccion
        if (e && e.detail && e.detail.videoid && e.detail.progress) {
          if (e.detail.videoid == ep.id) {
            ep.data.bookmark = e.detail.progress;
            return Object.assign({}, ep, {
              bookmark: e.detail.progress
            });
          }
        }
      }

      if (responseBookmark) {
        let bookmark = responseBookmark.vistime && responseBookmark.vistime.last.progress || 0;
        let time_progress = responseBookmark.vistime && responseBookmark.vistime.last.time || '00:00:00';
        let image_frames = responseBookmark.image_frames || image_still;
        time_progress = time_progress.replace(':', 'h-').replace(':', 'm-');
        image_frames = image_frames.replace('00h-00m-00', time_progress);
        cover =  image_frames;

        if (ep.data) {
          ep.data.bookmark = bookmark;
        }

        return Object.assign({}, ep, {
          bookmark,
          time_progress,
          cover,
          image_frames,
          image_still,
        });
      }

      return Object.assign({}, ep, {
        cover: image_still,
      });
    });

    if (withResponseBookmark) {
      this.setState({
        loadingBookmarks: true,
        items
      });
    }

  }

    buildEpisodes() {
      this.setState({
        items: this.props.episodes.map(ep => {
          return {
            id: ep.id,
            episode: ep.episode_number,
            title: `${ep.episode_number}. ${ep.title_episode}`,
            proveedor_code: ep.proveedor_code,
            provider: ep.proveedor_code === 'amco' ? 'default' : ep.proveedor_code,
            format_types: ep.format_types,
            live_enabled: ep.live_enabled,
            current: ep.current ? true : false,
            clickHandler: () => { this.props.handleEpisodeClick(ep) },
            cover: this.getCoverImage(ep.image_still),
            image_still: ep.image_still,
            data: ep,
          }
        }),
      });
    }

    render() {
        const items = this.state.items;
        const { onHandleFocusEpisodes } = this.props;

        return (
            <div className="vcard-seasons-carousel">
              <div className="special-ribbon-carousel">
                <Ribbon
                  index={0}
                  id="episodesvcard"
                  hideTitles
                  type="landscape"
                  visibleNumber={this.props.visibleEpisodes}
                  hideInnerTitle={true}
                  items={items}
                  onHandleFocusEpisodes={onHandleFocusEpisodes}
                  idsRibbonsUpAndDown={ {
                      0: {
                      focusUp: ".elementopredeterminado",
                      focusDown: "#vcardrecomendationribbon_classic_link_1"
                      }
                    }
                  }
                />
              </div>
            </div>
        )
    }
}

export default Episodes



// WEBPACK FOOTER //
// ./src/components/EpisodeSelection/Episodes.jsx